// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__ZRuSq","loader_circle":"styles_loader_circle__HCBuI","circle_classic":"styles_circle_classic__Gfd9w"};